import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { PiniaColada, PiniaColadaQueryHooksPlugin } from '@pinia/colada'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import Zapan2 from './plugins/zapan2'
import daisuke from '@tsyl/daisuke-auth-plugin'
import i18n from './plugins/i18n'
import { loadFonts } from './plugins/webfontloader'
import settings from '@/settings'
import sentry from './plugins/sentry'
import { installStaleChunkReload } from './plugins/staleChunkReload'
import { bootstrap } from './plugins/bootstrap'

const app = createApp(App)

app.use(sentry, { router })
installStaleChunkReload(router)

loadFonts()

app.use(createPinia())
app.use(PiniaColada, {
  plugins: [
    PiniaColadaQueryHooksPlugin({
      onError(error, entry) {
        console.error(`[Pinia:${entry.key[0]}]:`, error)
        Sentry.captureException(error)
      },
    }),
  ],
})
app.use(router)
app.use(vuetify)
app.use(Zapan2)
app.use(i18n)
const { userRepository } = bootstrap(app)
app.use(daisuke as any, {
  router,
  domain: settings.AUTH0_DOMAIN,
  clientId: settings.AUTH0_CLIENT_ID,
  audience: settings.AUTH0_AUDIENCE,
  getOrganizations: (page: number, itemsPerPage: number) =>
    userRepository.findMyOrganizations(page, itemsPerPage),
})
app.mount('#app')
